// AppHomeRedirect.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Adjust based on your auth hook

export default function AppHomeRedirect() {
  const { currentUser } = useAuth(); // Assuming currentUser is null when not logged in
  return currentUser ? <Navigate to="dashboard" replace /> : <Navigate to="signup" replace />;
}